import axios from "../api/axios";
import useAuth from "./useAuth";

const API_URL = process.env.REACT_APP_API_URL;
const REFRESH_URL = API_URL + "/api/v1/agents/refresh";

const useRefreshToken = () => {
  const { setAuth } = useAuth();
  const refresh = async () => {
    try {
      const response = await axios.post(REFRESH_URL, null, {
        withCredentials: true,
      });
      setAuth((prev) => {
        return {
          ...prev,
          access_token: response.data.access_token,
          agent_id: response.data.agent_id,
          isAuthenticated: true,
          role: response.data.role,
        };
      });
      return true;
    } catch (error) {
      console.log(error);
      return false;
    }
  };
  return refresh;
};

export default useRefreshToken;
